import type { FC } from 'react';

import styles from './Casca.module.scss';

// A FOTO DE UM PERFIL NA CASCA (a faixa, o alto do menu, a lista): a do Spotify quando existe; sem
// ela, as iniciais do nome. A imagem padrão de artista era a mesma para todos os perfis sem foto, e
// no tema escuro sumia no fundo da faixa: ali, a foto é o que diz qual perfil é qual.

export const iniciais = (nome: string) => {
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  const letras = partes.length > 1 ? `${partes[0][0]}${partes[partes.length - 1][0]}` : (partes[0] ?? '?').slice(0, 2);
  return letras.toUpperCase();
};

// O AVATAR VAZIO É UM SÓ EM TODA A WEB (pedido do Lucas, 09/10/2026): as iniciais, na faixa, no
// menu, no Início, em Seus perfis, no Perfil e na página pública. A imagem padrão antiga
// (/images/artist.png) conta como sem foto. `grande`: o avatar de 64px ou mais, com letra maior.
const SEM_FOTO = /\/images\/artist\.png$/;

export const FotoDoPerfil: FC<{ nome: string; imagem?: string | null; className?: string; grande?: boolean }> = ({ nome, imagem, className, grande }) => (imagem && !SEM_FOTO.test(imagem)
  ? <img src={imagem} alt='' className={`${styles.foto} ${className ?? ''}`} />
  : <span className={`${styles.foto} ${styles.iniciais} ${grande ? styles.iniciaisGrandes : ''} ${className ?? ''}`} aria-hidden>{iniciais(nome)}</span>);
